import {FETCH_FIRM_SETTING_SUCCESS} from "./actions";

const initialState = {
	commissionEnabled: false,
	admin : false,
	companyId : null,
	deleted : false,
	enabled : false,
	paid : false,
	risk : false,
	severity : false,
	subscriber : false,
	subscription : false,
	ace : false,
	lastTradingDate : null
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_FIRM_SETTING_SUCCESS:
			return action.data;
		default:
			return state;
	}
};


export default reducer;


// WEBPACK FOOTER //
// ./src/settings/firm/redux/reducers.js